"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cards = require("@site/cards");
var _TestimonialCardStyling = _interopRequireDefault(require("./styles/TestimonialCardStyling"));
var _uxUtils = require("@site/ux-utils");
/**
 * TestimonialCardSection component renders a section containing testimonial cards.
 *
 * @param {Object} props - The properties object.
 * @param {Array} props.testimonials - An array of testimonial objects.
 * @param {string} props.testimonials[].eyebrowTitle - The eyebrow title of the testimonial.
 * @param {string} props.testimonials[].text - The main text of the testimonial.
 * @param {string} props.testimonials[].name - The name of the person giving the testimonial.
 * @param {string} props.testimonials[].title - The title or position of the person giving the testimonial.
 * @param {string} [props.testimonials[].imageSrc] - The source URL of the image associated with the testimonial.
 *
 * @example
 * const testimonials = [
 *   {
 *     eyebrowTitle: "Great Service",
 *     text: "This is the best service I have ever used.",
 *     name: "John Doe",
 *     title: "CEO, Company Inc.",
 *     imageSrc: "https://example.com/image.jpg"
 *   },
 *   {
 *     text: "Highly recommend this to everyone.",
 *     name: "Jane Smith",
 *     title: "CTO, Another Company"
 *   }
 * ];
 *
 * <TestimonialCardSection testimonials={testimonials} />
 */
const TestimonialCardSection = ({
  title = '',
  testimonials = []
}) => {
  return /*#__PURE__*/_react.default.createElement(_TestimonialCardStyling.default, {
    "data-cy": "testimonial-card-section",
    "data-testid": "testimonial-card-section"
  }, /*#__PURE__*/_react.default.createElement("h4", {
    "data-cy": "testimonial-card-section-title",
    "data-testid": "testimonial-card-section-title",
    className: "mb-4"
  }, (0, _uxUtils.useFormatMessage)(title)), /*#__PURE__*/_react.default.createElement("div", {
    className: "testimonial-card-section"
  }, testimonials?.map(testimonial => {
    const CardComponent = testimonial.imageSrc ? _cards.TestimonialCardWithImage : _cards.TestimonialCard;
    return /*#__PURE__*/_react.default.createElement(CardComponent, (0, _extends2.default)({
      key: testimonial.text
    }, testimonial));
  })));
};
TestimonialCardSection.propTypes = {
  title: _propTypes.default.string.isRequired,
  testimonials: _propTypes.default.arrayOf(_propTypes.default.shape({
    eyebrowTitle: _propTypes.default.string,
    text: _propTypes.default.string.isRequired,
    authorName: _propTypes.default.string.isRequired,
    authorTitle: _propTypes.default.string.isRequired,
    imageSrc: _propTypes.default.string
  })).isRequired
};
var _default = exports.default = TestimonialCardSection;